import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet';
import { faExternalLink, faBookmark } from '@fortawesome/pro-light-svg-icons';
import practicalUX from "assets/articles/practical-ux-cover.jpg";
import howToTalk from "assets/articles/how-to-talk.jpg";
import betterProjects from "assets/articles/better-projects.png";
import wireframe from "assets/articles/wireframe.png";
import teamBuilding from "assets/articles/team-building.jpg";

const Articles = () => {
  const articles = [
    {
      title: "AI for UX: The CLI Bridge",
      link: "https://medium.com/@LadyCarni/ai-for-ux-the-cli-bridge-3abdfa8e8d9d",
      date: "September 15, 2026",
      summary: "Part 5 of the AI for UX series moves past the chat window and into the command line, covering tools like Claude Code for prototyping, accessibility audits, and automation. This article covers what a CLI-based workflow actually looks like day to day, when it's worth the setup cost over a GUI tool, and how to fold it into existing UX practice without losing the parts of the job that still need a human.",
      id: 'b5e5c387-c901-4a05-85ad-e4af4b5a3160'
    },
    {
      title: "AI for UX: AI Across the UX Workflow — Writing, Prototyping, and Handoff",
      link: "https://medium.com/@LadyCarni/ai-for-ux-ai-across-the-ux-workflow-writing-prototyping-and-handoff-4076a991abe0",
      date: "June 28, 2026",
      summary: "The second half of the UX workflow is where AI output starts to look finished; polished microcopy, clickable prototypes, thorough spec documents; which is exactly when you need to be most critical. This article covers ideation, UX writing, prototyping, usability testing, and handoff documentation, with a practical framework for knowing when to evaluate with AI, when to generate with a tight brief, and when Figma is still the better tool. Five phases, five paste-ready prompts, and an honest take on where AI earns its place and where it doesn't.",
      id: 'a7ee2521-ce13-4628-804f-e3aa7c55d321'
    },
    {
      title: "AI for UX: AI Across the UX Workflow - Research and Discovery",
      link: "https://medium.com/@LadyCarni/ai-for-ux-ai-across-the-ux-workflow-research-and-discovery-499845f73a63",
      date: "May 20, 2026",
      summary: "The front end of the UX process is where AI has the highest potential leverage and the highest potential for false confidence. This article walks through four research phases; planning, interviewing, synthesis, and communicating insights; with worked examples that show the full arc from messy input to actionable output. The goal isn't to make AI do your research for you; it's to spend less time on the mechanical parts so you have more thinking left for the work that actually requires it.",
      id: 'ffbb2aa4-694a-4fc2-8f92-e88b1751f8db'
    },
    {
      title: "AI for UX: Prompts, Preferences, and Configuration",
      link: "https://medium.com/@LadyCarni/prompts-preferences-and-configuration-007cd743a89a",
      date: "May 13, 2026",
      summary: "Part 2 of the AI for UX series: system prompts, custom instructions, and the prompting patterns that make the difference between mediocre and useful.",
      id: '3fb39915-eec4-492b-9dae-075b367fbc82'
    },
    {
      title: "AI for UX: The Guide you wish someone had given you sooner",
      link: "https://medium.com/design-bootcamp/ai-for-ux-the-guide-you-wish-someone-had-given-you-sooner-d1401c9f2e0b",
      date: "April 30, 2026",
      summary: "The article I wish someone had handed me when AI started showing up everywhere in my UX workflow. Part 1 covers the foundations: how LLMs work, what separates a chat interface from a CLI tool, and why understanding the landscape is the first step to leading in it.",
      id: 'ed47cddf-8c70-4dee-bf81-43e77b054063'
    },
    {
      title: "Saying No with diplomacy",
      link: "https://medium.com/@LadyCarni/saying-no-with-diplomacy-d7f07e9ccd6d",
      date: "July 28, 2025",
      summary: "Saying no diplomatically can be challenging, but using a positive and constructive approach helps maintain good relationships and shows that we're still supportive, even if we can't fulfill the request as asked. Here are some conversational tips to help reframe or redirect requests.",
      id: '6551d965-8c02-48fe-9880-e6df60397b6f',
    },
    {
      title: "UX Resources",
      link: "https://medium.com/@LadyCarni/ux-resources-235248952303",
      date: "February 14 2024",
      summary: "Maybe you're interested in getting started in User Experience (UX), or maybe you're just keen to brush up your existing skills. Here are a list of basic resources I've found to be helpful for various scenarios.",
      id: 'b1121a3c-5a90-4c65-87c4-647bfd8ab27d',
    },
    {
      title: "Remote Team Building",
      link: "https://medium.com/@LadyCarni/remote-team-building-7c2a03570703",
      date: "June 23, 2020",
      summary: "When you're ready to take a break and have some fun with your team, you likely want to go beyond some of the more traditional corporate team building exercises.",
      id: 'c3f9e1d2-4b5a-4c6d-8f7e-9a2b3c4d5e6f',
    },
    {
      title: "Saying goodbye",
      link: "https://medium.com/@LadyCarni/saying-goodbye-99be8253b890",
      date: "November 29, 2019",
      summary: "To explain why I've decided to move on, I'll need to take you all the way back to early 2012; back to the beginning.",
      id: 'd4e5f6g7-8h9i-10j11-12k13-14l15m16n17o',
    },
    {
      title: "FontAwesome Pro for your Ionic/Angular project",
      link: "https://medium.com/vehikl-news/fontawesome-pro-for-your-ionic-angular-project-c99c00b47c3",
      date: "September 27, 2019",
      summary: "This is a love story between FontAwesome's Pro icon pack (v5) and an Ionic (v4) project using Angular (v7).",
      id: 'e5f6g7h8-9i10-11j12-13k14-14l15m16n17o',
    },
    {
      title: "Practical UX: Tools of the Trade",
      link: "https://medium.com/@LadyCarni/practical-ux-tools-of-the-trade-5a84b9d42491",
      date: "March 19, 2019",
      summary: "The third in the Practical UX series; sharing a collection of tools and techniques for the pragmatic UX professional",
      id: 'f6g7h8i9-10j11-12k13-13l14-15m16n17o18p',
    },
    {
      title: "Practical UX: The Who and the Why",
      link: "https://blog.prototypr.io/practical-ux-the-who-and-the-why-13e24a34ee53",
      date: "March 4, 2019",
      summary: "The second in the Practical UX series. We build software for people. When desining and bulding, we must ask: Who are they, and what problem are we solving for them?",
      id: 'g7h8i9j10-11k12-13l14-14m15n16o17p',
    },
    {
      title: "Practical UX: The Perspective",
      link: "https://medium.com/@LadyCarni/practical-ux-the-perspective-d8908313336d",
      date: "January 10, 2019",
      summary: "The first in the Practical UX series; framing the mindset and the outlook of the pragmatic UX professional.",
      id: 'h8i9j10k11-12l13-13m14-14n15o16p17q',
    },
    {
      title: "Giving Talks: 101",
      link: "https://medium.com/@LadyCarni/giving-talks-101-29f3cc4d36ac",
      date: "November 1, 2018",
      summary: "Addressing fears and common obstacles so you can talk in front of strangers and give back to the community.",
      id: 'i9j10k11-12l13-13m14-14n15o16p17q18r',
    },
    {
      title: "Running Better Software Projects",
      link: "https://medium.com/vehikl-news/running-better-software-projects-c589f017c63f",
      date: "July 5, 2017",
      summary: "Learn how to facilitate effective client meetings, organize phases of a project, manage sprints, and improve collaboration on your team.",
      id: 'j10k11-12l13-13m14-14n15o16p17q18r19s',
    },
    {
      title: "Imposter Syndrome",
      link: "https://code.likeagirl.io/imposter-syndrome-c2bdad47d88d",
      date: "March 4, 2017",
      summary: "Why is it, despite our success we still have that nagging voice in the backs of our minds taunting us with accusations of fraud, fraud, FRAUD!!",
      id: 'k11l12-13m14-14n15o16p17q18r19s20t',
    },
    {
      title: "Stock Photo Resources",
      link: "https://medium.com/@LadyCarni/im-sure-you-ve-been-there-you-re-designing-a-brand-spanking-new-site-and-you-know-damned-well-fbbd8b13fe43",
      date: "November 4, 2016",
      summary: "Stock images today aren't the libraries of a few years ago. Here are just a few to get you started!",
      id: 'l12m13-14n15o16p17q18r19s20t21u',
    },
    {
      title: "Wireframe vs. Prototype",
      link: "https://medium.com/vehikl-news/wireframe-vs-prototype-a77afa83311a",
      date: "July 12, 2016",
      summary: "Which is best? The highly-detailed, more refined prototype, or the moderately-detailed, flexible wireframe.",
      id: 'm13n14-15o16p17q18r19s20t21u22v',
    },
    {
      title: "Your Product: Design Built",
      link: "https://medium.com/vehikl-news/time-management-facilitating-meetings-prioritizing-work-delegating-tasks-collaborating-with-efbdd78f51d1",
      date: "May 19, 2016",
      summary: "The planning and execution of an efficient, meaningful, cost-effective user experience.",
      id: 'n14o15-16p17q18r19s20t21u22v23w',
    },
    {
      title: "10 Ways to Teach Kids to Code",
      link: "https://medium.com/vehikl-news/10-ways-to-teach-kids-to-code-1c5e4b68a247",
      date: "January 9, 2016",
      summary: "Board games, apps, websites, and tutorials for helping teach kids how to code.",
      id: 'o15p16-17q18r19s20t21u22v23w24x',
    },
  ];

  return (
    <div className="articles full-height">
      <Helmet>
        <title>Caryn Farvour</title>
        <meta property="og:title" content="Caryn Farvour" />
        <meta property="og:description" content="A professional UX portfolio showcasing industry insights, creative projects, hobbies, and recipes, blending design expertise with personal passion." />
        <meta property="og:image" content="%PUBLIC_URL%/assets/about/caryn-portrait.jpg" />
        <meta property="og:url" content="https://carynfarvour.design" />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="article-feature-container">
        <span className="landmark"><FontAwesomeIcon icon={faBookmark} /> Top Articles</span>

        <div className="article-features">
          <div className="article-feature main-feature">
            <div className="article-feature-content main-feature-content filter shadow">
              <a href="https://medium.com/@LadyCarni/practical-ux-the-perspective-d8908313336d" target="_blank" rel="noreferrer">
                <div className="article-image image bottom">
                  <img src={practicalUX} alt="Practical UX article" />
                </div>
                <div className="article-info">
                  <h3>Practical UX: The Perspective <FontAwesomeIcon icon={faExternalLink} /></h3>
                  <span>Applying user experience principles to every day practices</span>
                </div>
              </a>
            </div>
          </div>

          <div className="article-feature secondary-features">
            <div className="article-feature-content secondary-feature-content filter shadow">
              <a href="https://medium.com/vehikl-news/running-better-software-projects-c589f017c63f" target="_blank" rel="noreferrer">
                <div className="article-image image bottom">
                  <img src={betterProjects} alt="Example of whiteboarding" />
                </div>
                <div className="article-info">
                  <h4>Better Software Projects <FontAwesomeIcon icon={faExternalLink} /></h4>
                </div>
              </a>
            </div>
            <div className="article-feature-content secondary-feature-content filter shadow">
              <a href="https://medium.com/@LadyCarni/remote-team-building-7c2a03570703" target="_blank" rel="noreferrer">
                <div className="article-image image bottom">
                  <img src={teamBuilding} alt="Team standing together" />
                </div>
                <div className="article-info">
                  <h4>Remote Team Building <FontAwesomeIcon icon={faExternalLink} /></h4>
                </div>
              </a>
            </div>
            <div className="article-feature-content secondary-feature-content filter shadow">
              <a href="https://medium.com/@LadyCarni/giving-talks-101-29f3cc4d36ac" target="_blank" rel="noreferrer">
                <div className="article-image image bottom">
                  <img src={howToTalk} alt="Talking at a conference" />
                </div>
                <div className="article-info">
                  <h4>Giving Talks: 101 <FontAwesomeIcon icon={faExternalLink} /></h4>
                </div>
              </a>
            </div>
            <div className="article-feature-content secondary-feature-content filter shadow">
              <a href="https://medium.com/vehikl-news/time-management-facilitating-meetings-prioritizing-work-delegating-tasks-collaborating-with-efbdd78f51d1" target="_blank" rel="noreferrer">
                <div className="article-image image bottom">
                  <img src={wireframe} alt="Example of wireframing" />
                </div>
                <div className="article-info">
                  <h4>Design Built <FontAwesomeIcon icon={faExternalLink} /></h4>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="article-feed">
        <div className="title">
          <span className="landmark"><FontAwesomeIcon icon={faBookmark} /> Recent Articles</span>
        </div>
        <div className="articles">
          {articles.map(({ id, title, link, date, summary }) => (
            <div className="article-snippet" key={id}>
              <div className="article-meta">
                {date}
              </div>
              <div className="article-body">
                <a href={`${link}`} target="_blank" rel="noreferrer">
                  <h2>{title}</h2>
                  <p className="article-summary">{summary}<span className="continue">Continue<FontAwesomeIcon icon={faExternalLink} /></span></p>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Articles;
